import React, { useEffect, useState } from 'react'
import useApp from 'hooks/useApp'
import { Button, InputX, LayerBottom } from 'components'
import { useNavigate } from 'react-router-dom'
import { influencerState } from './states'
import {  useSetRecoilState } from 'recoil'
import styles from './index.module.css'
import Lib from 'library'



const InfluencerProfile = () => {

	const App = useApp()
	const navigate = useNavigate()
	const [profileImg, setProfileImg] = useState(false)
	const [nickName, setNickName] = useState('')
	const [overlapState, setOverlapState] = useState(true)
	const [prflData, setPrflData] = useState()
	const [profile, setProfile] = useState(0)
	const [profileBasic, setProfileBasic] = useState('01')
	const [dupButtonDisabled, setDupButtonDisabled] = useState(true)
	const [buttonDisabled, setButtonDisabled] = useState(false)
	const [didDupCheck, setDidDupCheck] = useState(true)
	const setInfluenceInfo = useSetRecoilState(influencerState)

	const closeProfile = () => {
		setProfileImg(false)
	}

	const showProfile = () => {
		setProfileImg(true)
	}

	const overlapConfirm = (name) => {
		Lib.post(`/api/infl/chk/ncknmdup`, {
			ncknm: name
		}, data => {
			setOverlapState(data.dupCnt === "0" ? false : true)
			setDidDupCheck(data.dupCnt === "0")
			console.log(data)
		})
	}

	const onChange = (e) => {
		setDidDupCheck(false)
		setNickName(e.target.value);
	}

	const resetNickName = () => {
		Lib.get(`/api/infl/rncknm`, data => {
			setNickName(data.randNcknm)
			overlapConfirm(data.randNcknm)
			console.log(data)
		})
	}

	const overlapText = () => {
		if (overlapState === true) {
			return (
				<div>
					<span style={{ fontWeight: 'normal', fontSize: '1.4rem', lineHeight: '2rem', color: '#FF3333', marginTop: '0.5rem' }}>이미 사용중인 닉네임입니다.</span>
				</div>
			)
		} else if (dupButtonDisabled === true && overlapState === false) {
			return (
				<div>
					<span style={{ fontWeight: 'normal', fontSize: '1.4rem', lineHeight: '2rem', color: '#FF3333', marginTop: '0.5rem' }}>최소 1자리~최대 10자리까지 가능합니다.</span>
				</div>
			)
		} else {
			return (
				<div>
					<span style={{ fontWeight: 'normal', fontSize: '1.4rem', lineHeight: '2rem', color: '#298CFA', marginTop: '0.5rem' }}>사용가능한 닉네임입니다.</span>
				</div>
			)
		}
	}

	useEffect(() => {
		const empty = /\s/g;
		if (empty.test(nickName) || nickName === '') {
			setOverlapState(false)
			setDupButtonDisabled(true)
			setButtonDisabled(true)
		} else {
			setDupButtonDisabled(false)
			setButtonDisabled(false)
		}
	}, [nickName])

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")

		// 프로필 정보
		const profileData = [
			{
				prflCd: "01",
				prflPath: '/images/profile/influencer_profile01.svg',
			},
			{
				prflCd: "02",
				prflPath: '/images/profile/influencer_profile02.svg',
			},
			{
				prflCd: "03",
				prflPath: '/images/profile/influencer_profile03.svg',
			},
			{
				prflCd: "04",
				prflPath: '/images/profile/influencer_profile04.svg',
			},
			{
				prflCd: "05",
				prflPath: '/images/profile/influencer_profile05.svg',
			}
		]

		setPrflData(profileData);

		Lib.get(`/api/infl/rncknm`, data => {
			setNickName(data.randNcknm)
			overlapConfirm(data.randNcknm)
			console.log(data)
		})
	}, [])

	// 인플루언서 참여하기
	const onAgree = () => {
		if (!didDupCheck) {
			App.alert("닉네임 중복확인을 해 주세요.")
			return
		}
		overlapConfirm(nickName)
		if (overlapState === true || dupButtonDisabled === true) return
		if ((overlapState === false && dupButtonDisabled === false)) {
			Lib.post(`/api/infl/join`, {
				ncknm: nickName,
				prflCd: prflData[profile].prflCd
			}, data => {
				setInfluenceInfo(prev => ({
					...prev,
					ncknm: nickName,
					prflCd: prflData[profile].prflCd
				}))
				navigate("/home/participate", { state: {from: "/recommend"}, replace : true })
			})
		}
	}

	return (
		<div className="page">
			<div className="flex_1 padding">
				<h4>인플루언서가 되어<br />나의 자산을 뽐내보세요!</h4>
				<div className={`${styles["profile-area"]} mt_40`}>
					<div className={styles["user-img"]} onClick={showProfile}>
						<div className="img-box user-profile profile_80">
							<img src={"/images/profile/influencer_profile" + profileBasic + ".svg"} alt="프로필 이미지" />
						</div>
						<span className="camera-btn"><i className="icon icon_camera" /></span>
					</div>
					<div className="ml_20">
						<InputX onX={() => { setNickName('') }} type="text" value={nickName} onChange={onChange} maxlength={10} placeholder="닉네임 입력" id="" style={{ width: "15rem" }}></InputX>
						{overlapText()}
						<div className="mt_10">
							<Button disabled={dupButtonDisabled} className="btn btn--sm btn--line" onClick={() => overlapConfirm(nickName)}>중복확인</Button>
							<Button className="btn btn--sm btn--gray_line ml_5" onClick={resetNickName}>초기화</Button>
						</div>
					</div>
				</div>
				<div className={`${styles["info-box"]} padding mt_40`}>
					<p>인플루언서에 참여하시면 내가 연결한<br />마이데이터 정보를 사람들이 볼 수 있어요.</p>
					<span className="mt_10">그래도 걱정하지마세요. 내가 누구인지는 쉿! 비밀~<br />나를 구독하는 사람을 만들어보세요.</span>
				</div>
			</div>
			<div className="flex-shrink_0 padding">
				<Button className="btn btn--big" disabled={buttonDisabled} onClick={onAgree} >시작하기</Button>
			</div>

			<ProfileSelect show={profileImg} closeLayer={closeProfile} prflData={prflData} setProfile={setProfile} profile={profile} setProfileBasic={setProfileBasic} />
		</div>
	)
}

const ProfileSelect = ({ show, closeLayer, prflData, setProfile, profile, setProfileBasic }) => {

	const onChangeProfile = () => {
		setProfileBasic("0" + (profile + 1))
		closeLayer(closeLayer);
	}

	return (
		<LayerBottom title="변경하실 프로필을 선택하세요." show={show} closeLayer={closeLayer} outside={
			<Button className="btn btn--big btn-layer" onClick={onChangeProfile}>저장</Button>
		}>
			<div className="profile-select">
				{prflData && (
					prflData.map((item, index) => {
						return (
							<div key={index} className={`${profile === index ? "active" : ""} img-box`} onClick={() => setProfile(index)}>
								<div className="inner"><img src={item.prflPath} alt="" /></div>
							</div>
						)
					})
				)}
			</div>
		</LayerBottom>
	)
}

export default InfluencerProfile
